/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineAvailableTagFilters {
    getFixupPrototypeFunction() { return TagBaselineAvailableTagFilters.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineAvailableTagFilters>): TagBaselineAvailableTagFilters {
        let obj = Object.assign(new TagBaselineAvailableTagFilters(), model);
        TagBaselineAvailableTagFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineAvailableTagFilters>): TagBaselineAvailableTagFilters {
        if (!model) return null;
        return TagBaselineAvailableTagFilters.newInstance(<TagBaselineAvailableTagFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineAvailableTagFilters) {
        if (!obj) return;

        models.TagBaselineAvailableTagFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineAvailableTagFilters): boolean {
        Object.setPrototypeOf(obj, TagBaselineAvailableTagFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.AccountFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Text filter the tag keys
     */
    tag_key_query: string;

    /**
     * Account filters for the tags
     */
    filters: models.AccountFilters;

}
